export enum ValidPaymentStatusType {
    APPROVED = 'approved',
    IN_PROCESS = 'in-process',
    PENDING = 'pending',
    PROCESSED = 'processed'
}
